import VAR_COMMON_CONSTANTS from "../constants/globalVariables";

/**
 * Calculates a range with a buffer applied to the min and max values.
 * Returns an object with minRange and maxRange, or null if input is null.
 * @param {number | null} min - The minimum value.
 * @param {number | null} max - The maximum value.
 * @returns {{ minRange: number | null, maxRange: number | null }}
 */
export const calculateRangeWithBuffer = (min: number | null, max: number | null): { minRange: number | null, maxRange: number | null } => {
  const buffer = VAR_COMMON_CONSTANTS.COVERAGE_PLOTS_RANGE_BUFFER;
  const minRange = min == null ? null : min * buffer;
  const maxRange = max == null ? null : max * buffer;
  return {minRange, maxRange};
};

/**
 * Returns the largest finite number in the array, ignoring non-finite values.
 * Returns -Infinity if no finite values are found.
 * @param {number[]} arr - Array of numbers.
 * @returns {number}
 */
export const getMaxFinite = (arr: number[]): number => {
  let max = -Infinity;
  for (let i = 0; i < arr.length; i++) {
    const val = arr[i];
    if (Number.isFinite(val) && val > max) {
      max = val;
    }
  }
  return max;
}

/**
 * Returns the smallest finite number in the array, ignoring non-finite values.
 * Returns Infinity if no finite values are found.
 * @param {number[]} arr - Array of numbers.
 * @returns {number}
 */
export const getMinFinite = (arr: number[]): number => {
  let min = Infinity;
  for (let i = 0; i < arr.length; i++) {
    const val = arr[i];
    if (Number.isFinite(val) && val < min) {
      min = val;
    }
  }
  return min;
}